import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class AppService {
  blockUI = false;
  turnOffBlockUI = false;
  turnOffBlockUIOnce = false;
}
